import { lazy } from "react";

export const WriterProfileAsync = lazy(() => import("./WriterProfile"));
